var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('RouterView'),(_vm.showAIChatWidget)?_c('AIChatWidget'):_vm._e(),(_vm.showAIChatWidget && _vm.$isAdminAndClient())?_c('FloatingUploadPanel'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }